import { Reducer, UnknownAction } from 'redux';
import { FunctionMap } from '../../types';

export function createReducer<S = any>(functionMap: FunctionMap, defaultState: S): Reducer {
  return (state: S, action: UnknownAction) => {
    if (!state) {
      return defaultState;
    }

    const func = functionMap[action.type];
    return func ? func(state, action) : state;
  };
}
